__turbopack_context__.v({
  "analysisItem": "CallDetail-module__7a_sUq__analysisItem",
  "analysisList": "CallDetail-module__7a_sUq__analysisList",
  "audioPlayer": "CallDetail-module__7a_sUq__audioPlayer",
  "container": "CallDetail-module__7a_sUq__container",
  "footerActions": "CallDetail-module__7a_sUq__footerActions",
  "footerActionsRight": "CallDetail-module__7a_sUq__footerActionsRight",
  "footerBtnDanger": "CallDetail-module__7a_sUq__footerBtnDanger",
  "footerBtnGhost": "CallDetail-module__7a_sUq__footerBtnGhost",
  "high": "CallDetail-module__7a_sUq__high",
  "infoBlock": "CallDetail-module__7a_sUq__infoBlock",
  "infoGrid": "CallDetail-module__7a_sUq__infoGrid",
  "infoLabel": "CallDetail-module__7a_sUq__infoLabel",
  "infoValue": "CallDetail-module__7a_sUq__infoValue",
  "itemBadge": "CallDetail-module__7a_sUq__itemBadge",
  "itemDescription": "CallDetail-module__7a_sUq__itemDescription",
  "itemHeader": "CallDetail-module__7a_sUq__itemHeader",
  "itemIcon": "CallDetail-module__7a_sUq__itemIcon",
  "itemLabel": "CallDetail-module__7a_sUq__itemLabel",
  "itemQuote": "CallDetail-module__7a_sUq__itemQuote",
  "level0": "CallDetail-module__7a_sUq__level0",
  "level1": "CallDetail-module__7a_sUq__level1",
  "level2": "CallDetail-module__7a_sUq__level2",
  "low": "CallDetail-module__7a_sUq__low",
  "mainContent": "CallDetail-module__7a_sUq__mainContent",
  "mediaSection": "CallDetail-module__7a_sUq__mediaSection",
  "mediaWrapper": "CallDetail-module__7a_sUq__mediaWrapper",
  "medium": "CallDetail-module__7a_sUq__medium",
  "metaGrid": "CallDetail-module__7a_sUq__metaGrid",
  "metaItem": "CallDetail-module__7a_sUq__metaItem",
  "metaItemBlocker": "CallDetail-module__7a_sUq__metaItemBlocker",
  "metaItemNextStep": "CallDetail-module__7a_sUq__metaItemNextStep",
  "metaItemTopic": "CallDetail-module__7a_sUq__metaItemTopic",
  "metaLabel": "CallDetail-module__7a_sUq__metaLabel",
  "metaSection": "CallDetail-module__7a_sUq__metaSection",
  "metaValue": "CallDetail-module__7a_sUq__metaValue",
  "noteSection": "CallDetail-module__7a_sUq__noteSection",
  "noteTextarea": "CallDetail-module__7a_sUq__noteTextarea",
  "previewPlaceholder": "CallDetail-module__7a_sUq__previewPlaceholder",
  "sectionTitle": "CallDetail-module__7a_sUq__sectionTitle",
  "summaryCard": "CallDetail-module__7a_sUq__summaryCard",
  "summaryText": "CallDetail-module__7a_sUq__summaryText",
  "tabPane": "CallDetail-module__7a_sUq__tabPane",
  "tabPaneFull": "CallDetail-module__7a_sUq__tabPaneFull",
});
